import { render, staticRenderFns } from "./WeddingGift.vue?vue&type=template&id=13c46e7f&scoped=true&"
import script from "./WeddingGift.vue?vue&type=script&lang=js&"
export * from "./WeddingGift.vue?vue&type=script&lang=js&"
import style0 from "./WeddingGift.vue?vue&type=style&index=0&id=13c46e7f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c46e7f",
  null
  
)

export default component.exports